import Common from '@/utils/saas/common' // 工具类

// 银行卡快捷充值页面初始化
export function initRechargeBankquickApi(data) {
  return Common.createRequest('trade-api', 'customer_person_recharge_bankquick_init', data, '快捷充值初始化')
}

// 银行卡快捷充提交
export function submitRechargeBankquickApi(data) {
  return Common.createRequest('trade-api', 'customer_person_recharge_bankquick_submit', data, '快捷充值提交')
}

// 银行卡快捷充值确认
export function confirmRechargeBankquickApi(data) {
  return Common.createRequest('trade-api', 'customer_person_recharge_bankquick_confirm', data, '快捷充值确认')
}
